import * as THREE from 'three';
import type { GameScene } from '../core/Scene';

export class TrashCan {
  readonly mesh: THREE.Group;
  readonly catchRadius: number;
  private readonly bodyMat: THREE.MeshLambertMaterial;
  private readonly fullColor = new THREE.Color(0xff2222);
  private readonly emptyColor = new THREE.Color(0x888888);

  constructor(catchRadius: number) {
    this.catchRadius = catchRadius;
    this.mesh = new THREE.Group();

    this.bodyMat = new THREE.MeshLambertMaterial({ color: 0x888888 });
    const body = new THREE.Mesh(
      new THREE.CylinderGeometry(0.45, 0.35, 0.9, 8),
      this.bodyMat,
    );
    body.position.y = 0.45;

    const lidMat = new THREE.MeshLambertMaterial({ color: 0x666666 });
    const lid = new THREE.Mesh(
      new THREE.CylinderGeometry(0.5, 0.45, 0.1, 8),
      lidMat,
    );
    lid.position.y = 0.95;

    this.mesh.add(body, lid);
  }

  // Lerps body color from gray → red as fill increases
  updateFill(count: number, capacity: number): void {
    const t = Math.min(count / capacity, 1);
    this.bodyMat.color.copy(this.emptyColor).lerp(this.fullColor, t);
  }

  addTo(scene: GameScene): void {
    scene.add(this.mesh);
  }

  dispose(): void {
    this.mesh.traverse((obj) => {
      if (obj instanceof THREE.Mesh) {
        obj.geometry.dispose();
        (obj.material as THREE.Material).dispose();
      }
    });
  }
}
